import { type LngLatLike, Map, Marker, FlyToOptions } from "mapbox-gl";

export interface PanelMarker {
  initPanelMarker(theMap: Map, marker: HTMLDivElement): void;
  place(lngLat: LngLatLike, disableFlyTo?: boolean, zoom?: number): void;
  remove(): void;
}

let _map: Map;
let _marker: Marker;
const animationDuration = 250;
export function useMapMarker(): PanelMarker {
  function initPanelMarker(map: Map, markerEl: HTMLDivElement) {
    _map = map;
    _marker = new Marker(markerEl, {
      offset: [0, 12],
      anchor: "bottom",
    }).remove();
  }

  function place(lngLat: LngLatLike, disableFlyTo = false, zoom?: number) {
    if (!_map || !_marker) return;


    if (!disableFlyTo) {
      const flyToOptions: FlyToOptions = {
        center: lngLat
      }

      if (zoom) {
        flyToOptions.zoom = zoom;
      }

      _map.flyTo(flyToOptions);
    }

    const svg = _marker.getElement().querySelector("svg");

    _marker.setLngLat(lngLat).addTo(_map);

    if (svg) {
      svg.style.animation = `popOut ${animationDuration}ms ease-in forwards normal`;
    }
  }

  function remove(): void {
    if (_marker) {
      const svg = _marker.getElement().querySelector("svg");
      if (svg) {
        svg.style.animation = "";
        setTimeout(
          () =>
            (svg.style.animation = `popOut ${animationDuration}ms ease-in forwards reverse`),
          0
        );
      }
      setTimeout(() => _marker.remove(), animationDuration);
    }
  }

  return {
    initPanelMarker,
    place,
    remove,
  };
}
